import "core-js/modules/es.array.push.js";
import axios from "axios";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
import vailcode from "@utils/errcode";
import cookie from "js-cookie";
export default {
  name: "popTask",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"])
  },
  data() {
    return {
      modifyData: {},
      isUploading: false,
      isSubmit: false
    };
  },
  watch: {
    "$parent.popAirdropShow": {
      async handler(newVal, oldVal) {
        if (newVal) {
          this.modifyData = Object.assign({}, this.$parent.modifyData);
          this.modifyData.chainToken = `${this.modifyData.chain || ''}|${this.modifyData.token || ''}`;
          this.modifyData.rules = typeof this.modifyData.rules == 'object' ? this.modifyData.rules : JSON.parse(this.modifyData.rules);
        } else {
          this.isSubmit = false;
        }
      },
      immediate: true,
      deep: true
    },
    "modifyData": {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onFileChange(e, ref, field) {
      const formData = new FormData();
      formData.append('file', e.target.files[0]);
      if (!e.target.files[0].type.startsWith('image/')) {
        this.$refs[ref].value = '';
        this.$toasted.error('请选择图片');
        return false;
      }
      if (this.isUploading) return;
      this.isUploading = true;
      let token = cookie.get('token') || '';
      formData.append('_token', token);
      // 使用axios上传文件
      axios.post(`${loadConfig.http_host}/upload?_token=${token}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        let rs = response.data;
        if (rs.code == 0) {
          this.modifyData[field] = rs.data.url;
          this.$set(this.modifyData, field, rs.data.url);
        } else {
          this.$toasted.error(rs.message);
        }
        this.isUploading = false;
        this.$refs[ref].value = '';
      }).catch(error => {
        console.error(error);
        this.isUploading = false;
        this.$refs[ref].value = '';
      });
    },
    addRuleItem() {
      this.modifyData.rules.push("");
    },
    removeRuleItem(index) {
      this.modifyData.rules.splice(index, 1);
    },
    async onConfirm() {
      if (this.isSubmit) return false;
      this.isSubmit = true;
      this.modifyData.chain = this.modifyData.chainToken.split("|")[0] || '';
      this.modifyData.token = this.modifyData.chainToken.split("|")[1] || '';
      let rs = await this.$http.post("/airdrop/modify", this.modifyData);
      this.isSubmit = false;
      vailcode(rs, () => {
        this.$parent.getData();
        this.$parent.popAirdropShow = false;
      });
    }
  }
};